import * as React from 'react';

function SvgTwitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 20" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M21.54 5v.65c0 6.68-5 14.37-14 14.37A13.72 13.72 0 010 17.73a9.18 9.18 0 001.17.07 9.77 9.77 0 006.12-2.16 5 5 0 01-4.6-3.51 4.73 4.73 0 00.93.09 5 5 0 001.29-.17A5 5 0 011 7.09V7a4.76 4.76 0 002.23.63A5.07 5.07 0 011 3.46 5.2 5.2 0 011.67.92 13.86 13.86 0 0011.82 6.2a5.48 5.48 0 01-.13-1.15 5 5 0 014.93-5 4.87 4.87 0 013.59 1.59A9.55 9.55 0 0023.34.37a5 5 0 01-2.17 2.79A9.59 9.59 0 0024 2.37 10 10 0 0121.54 5z" />
    </svg>
  );
}

const MemoSvgTwitter = React.memo(SvgTwitter);
export default MemoSvgTwitter;
